<template>
    <span v-if="externalLink(params.value)">{{ params.value }}
        <font-awesome-icon
                :icon="['far', 'external-link-square']"
                size="lg"
        >
        </font-awesome-icon>
    </span>
</template>

<script>
  import Vue from 'vue';

  export default Vue.extend({
    methods: {
      externalLink(value) {
        return value > 0;
      }
    }
  });
</script>
